/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import {
  BORDER_BOTTOM,
  BORDER_TOP,
  CLICK_AND_SELECT_LABEL,
  cursorPointerRelPos,
  DELETE_LABEL,
  LIST_ITEM_BOX,
  LIST_ITEM_STYLE,
  NO_DATA_FOUND_TEXT,
  partTableStyles,
  SOURCE,
  UPDATE_LABEL,
  WIDTH_100
} from "../../../utils/constants/GlobalConstants";
import { List, ListItem, ListItemText } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LinkView from "../link/LinkView";
import CheckboxView from "../checkbox/CheckBoxView";
import "./DataList.css";
import Pagination from "./Pagination";
import { v4 as uuidv4 } from 'uuid';
import { CANCELLED_HEAD_CELLS, DC_HEAD_CELLS, HISTORY_HEAD_CELLS, MAIN_HEAD_CELLS, PARTS_HEAD_CELLS, PARTS_INSIDE_HEAD_CELLS, PARTS_MAINTENANCE_HEAD_CELLS, STATUS, STORE_HEAD_CELLS } from "../../../utils/constants/GlobalFormConstants";

const DataList = (props) => {
  const [val, setVal] = React.useState("");
  const [strname, setStrName] = React.useState("");
  const [rows, setRows] = React.useState([]);
  const [fullData, setFullData] = React.useState(null);
  let PageSize = 5;
  const newData = {};
  const [currentPage, setCurrentPage] = useState(1);
  React.useEffect(() => {
    setCurrentPage(1);
  }, [props.value]);
  React.useEffect(()=>{
    if(props?.source === SOURCE.MAIN || props?.source === SOURCE.INPROGRESS || props?.source === SOURCE.CANCELLED || props?.source === SOURCE.HISTORY){
      props.changePageNoAndSize(currentPage,PageSize);
    }
 
  },[currentPage,PageSize])
  React.useEffect(() => {
    let formattedData = [];

    if (props.source === SOURCE.DC) {
      formattedData = props.rows
        ? props.rows.map((dc) => ({
          checkbox: "",
          name: dc.distributionCenterName,
          city: dc.distributionCity,
        }))
        : [];
    } else if (props.source === SOURCE.MAIN) {
      setFullData(props.rows);
      formattedData = props.rows
        ? props.rows.map((item) => ({
          debiReg: item.debiRegistrationNumber,
          RevNum: item.revisionNumber ? item.revisionNumber : "",
          DisCenter: item.distributionCenter,
          store: item.store,
          BName: item.businessName,
          dealerNum: item.dealerNumber,
          tel: item.telephone,
          salesRep: item.salesRepName,
          statusReason: item.statusReason,
          FType: item.formType,
          modified: item.lastUpdatedTs,
        }))
        : [];
    } else if (props.source === SOURCE.PARTS) {
      setFullData(props.rows);
      formattedData = props.rows
        ? props.rows.map((part) => ({
          part: part.partNumber,
          quantity: part.quantity,
          btn: "",
        }))
        : [];
    } else if (props.source === SOURCE.PARTSINSIDE) {
      formattedData = props.rows
        ? props.rows.map((part) => ({
          checkbox: "",
          partNumber: part.partNumber,
        }))
        : [];
    } else if (props.source === SOURCE.INPROGRESS) {
      formattedData = props.rows
        ? props.rows.map((item) => ({
          debiReg: item.debiRegistrationNumber,
          DisCenter: item.distributionCenter,
          store: item.store,
          BName: item.businessName,
          dealerNum: item.dealerNumber,
          tel: item.telephone,
          salesRep: item.salesRepName,
          statusReason: item.statusReason,
          FType: item.formType,
          modified: item.lastUpdatedTs,
        }))
        : [];
    } else if (props.source === SOURCE.CANCELLED) {
      formattedData = props.rows
        ? props.rows.map((item) => ({
          debiReg: item.debiRegistrationNumber,
          RevNum: item.revisionNumber ? item.revisionNumber : "",
          DisCenter: item.distributionCenter,
          store: item.store,
          BName: item.businessName,
          dealerNum: item.dealerNumber,
          tel: item.telephone,
          modified: item.createdTs,
          statusReason: item.statusReason,

        }))
        : [];
    } else if (props.source === SOURCE.HISTORY) {
      formattedData = props.rows
        ? props.rows.map((item) => ({
          debiReg: item.debiRegistrationNumber,
          RevNum: item.revisionNumber ? item.revisionNumber : "",
          DisCenter: item.distributionCenter,
          store: item.store,
          BName: item.businessName,
          dealerNum: item.dealerNumber,
          tel: item.telephone,
          salesRep: item.salesRepName,
          statusReason: item.statusReason,
          FType: item.formType,
          modified: item.lastUpdatedTs,
          status: item.statusReason === "Closed" ? "Inactive" : "Active",
        }))
        : [];
    } else if (props.source === SOURCE.PARTS_MAINTENANCE) {
      formattedData = props.rows
        ? props.rows.map((part) => ({
          checkbox: "",
          partNumber: part.partNumber,
          remarks: part.remarks,
        }))
        : [];
    } else {
      formattedData = props.rows
        ? props.rows.map((store) => ({
          checkbox: "",
          name: `${store.storeId}-${store.storeName}`,
          storeName: store.storeName,
        }))
        : [];
    }
    setFullData(formattedData);
    setRows(formattedData);
  }, [props?.source, props?.data, props?.rows]);
  React.useEffect(() => {
    if (
      props?.searchedData &&
      (props?.source === SOURCE.DC ||
        props?.source === SOURCE.STORE ||
        props?.source === SOURCE.PARTSINSIDE ||
        props?.source === SOURCE.PARTS_MAINTENANCE)
    ) {
      let tmp;
      if (props?.source === SOURCE.DC) {
        tmp = fullData?.filter(
          (itm) =>
            itm?.name
              ?.toUpperCase()
              ?.includes(props?.searchedData?.toUpperCase()) ||
            itm?.city?.toUpperCase()?.includes(props.searchedData.toUpperCase())
        );
      } else if (
        props?.source === SOURCE.PARTSINSIDE ||
        props?.source === SOURCE.PARTS_MAINTENANCE
      ) {
        tmp = fullData?.filter((itm) =>
          itm?.partNumber
            ?.toUpperCase()
            ?.includes(props?.searchedData?.toUpperCase())
        );
      }
      else if (props?.source === SOURCE.STORE) {
        tmp = fullData?.filter(
          (itm) =>
            itm?.name
              ?.toUpperCase()
              ?.includes(props?.searchedData?.toUpperCase()) ||
            itm?.storeName
              ?.toUpperCase()
              ?.includes(props.searchedData.toUpperCase())
        );
      }
      setRows(tmp);
    } else if (
      props?.searchedData === "" &&
      (props?.source === SOURCE.DC ||
        props?.source === SOURCE.STORE ||
        props?.source === SOURCE.PARTSINSIDE ||
        props?.source === SOURCE.PARTS_MAINTENANCE)
    ) {
      if (props.source === SOURCE.DC) {
        let formattedData = props.rows
          ? props.rows.map((dc) => ({
            checkbox: "",
            name: dc.distributionCenterName,
            city: dc.distributionCity,
          }))
          : [];
        setRows(formattedData);
      } else if (props.source === SOURCE.STORE) {
        let formattedData = props.rows
          ? props.rows.map((store) => ({
            checkbox: "",
            name: `${store.storeId}-${store.storeName}`,
            storeName: store.storeName,
          }))
          : [];
        setRows(formattedData);
      } else if (props.source === SOURCE.PARTSINSIDE) {
        let formattedData = props.rows
          ? props.rows.map((part) => ({
            checkbox: "",
            partNumber: part.partNumber,
          }))
          : [];
        setRows(formattedData);
      } else if (props.source === SOURCE.PARTS_MAINTENANCE) {
        let formattedData = props.rows
          ? props.rows.map((part) => ({
            checkbox: "",
            partNumber: part.partNumber,
            remarks: part.remarks,
          }))
          : [];
          
        setRows(formattedData);
      }
    }
  }, [props.searchedData]);
  const headCells =
    props?.source === SOURCE.MAIN
      ? MAIN_HEAD_CELLS
      : props.source === SOURCE.DC
        ? DC_HEAD_CELLS
        : props.source === SOURCE.PARTS
          ? PARTS_HEAD_CELLS
          : props.source === SOURCE.PARTS_MAINTENANCE
            ? PARTS_MAINTENANCE_HEAD_CELLS
            : props.source === SOURCE.PARTSINSIDE
              ? PARTS_INSIDE_HEAD_CELLS
                : props.source === SOURCE.CANCELLED
                  ? CANCELLED_HEAD_CELLS
                  : props.source === SOURCE.HISTORY
                    ? HISTORY_HEAD_CELLS
                    : STORE_HEAD_CELLS

 
  
  const currentTableData = React.useMemo(() => {
    let firstPageIndex = (currentPage - 1) * PageSize;
    let lastPageIndex = firstPageIndex + PageSize;
    if(props?.source === SOURCE.MAIN || props?.source === SOURCE.INPROGRESS || props?.source === SOURCE.CANCELLED || props?.source === SOURCE.HISTORY)
    {
      firstPageIndex = 0;
     lastPageIndex = 5;
    }else{
      firstPageIndex = (currentPage - 1) * PageSize;
     lastPageIndex = firstPageIndex + PageSize;
    }
    return rows?.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, rows]);
  return (
    <>
      <Box sx={WIDTH_100}>
        {props.source !== SOURCE.MAIN && props.source !== SOURCE.PARTS && props.notShow !== true &&(
          <Box sx={{ py: 1 }}>{CLICK_AND_SELECT_LABEL}</Box>
        )}
        <List>
          {currentTableData && currentTableData?.length > 0 ? (
            currentTableData.map((data,ind) => (
              <Box key={uuidv4()} sx={BORDER_TOP}>
                {headCells.map((item, index) => {
                 return <ListItem key={index} sx={BORDER_BOTTOM}>
                    <ListItemText
                      primaryTypographyProps={{
                        style: LIST_ITEM_STYLE
                      }}
                      primary={item.label}
                    />
                    <Box
                      sx={LIST_ITEM_BOX}
                    >
                      {index === 0 &&
                        (props.source === SOURCE.MAIN ||
                          props.source === SOURCE.INPROGRESS ||
                          props.source === SOURCE.CANCELLED ||
                          props.source === SOURCE.HISTORY) ? (
                        <LinkView
                          testid="details-link"
                          onClickLink={() => {
                            props.onRowClick(data, index)
                          }}
                        >
                          {data[item.id]}
                        </LinkView>
                      ) : (props.source === SOURCE.DC ||
                        props.source === SOURCE.STORE ||
                        props.source === SOURCE.PARTS_MAINTENANCE ||
                        props.source === SOURCE.PARTSINSIDE) &&
                        index === 0 ? (
                        <CheckboxView
                          testid="check"
                          checked={
                            props.source === SOURCE.PARTSINSIDE
                              ? props?.selected?.index === index &&
                              strname === data["partNumber"]
                              : props.source === SOURCE.PARTS_MAINTENANCE
                                ? props?.selected?.index === index &&
                                props?.selected?.record?.partNumber ===
                                data["partNumber"]
                                : props.flag === "createDebi"
                                  ? props?.selected?.record?.name === data["name"]
                                  : props?.selected?.record?.name === data["name"]
                          }
                          onCheck={(e) => {
                            props.handleChecked(data["name"], data, index);
                            setStrName(
                              props.source === SOURCE.PARTSINSIDE 
    
                                ? data["partNumber"]
                                : props.source === SOURCE.PARTS_MAINTENANCE ? data["partNumber"] :data["name"]
                            );
                          }}
                        />
                        
                      ) : props.source === SOURCE.PARTS && index === 2 ? (
                        <Box sx={cursorPointerRelPos}>
                          <KeyboardArrowDownIcon
                            testid="down"
                            onClick={() => {
                              if (val !== "") {
                                setVal("");
                              } else {
                                setVal(data[SOURCE.PARTS]);
                              }
                            }}
                          />
                          {val === data[SOURCE.PARTS] &&
                            props?.username ===
                            props?.debiDetails?.debis[0]?.createdBy && (props?.debiDetails?.debis[0]?.statusReason !== STATUS.OPEN) && 
                            (props?.debiDetails?.debis[0]?.statusReason !== STATUS.CLOSED ) && 
                            props?.debiDetails?.docusignDetails &&
                                    props?.debiDetails?.docusignDetails?.length === 0 
                                      &&
                            
                              (
                              <div style={partTableStyles}>
                                <div
                                  testid="update"
                                  className="partsDrop"
                                  onClick={() =>
                                    props.updateClicked(data, newData)
                                  }
                                >
                                  {UPDATE_LABEL}
                                </div>
                                <div
                                  testid="delete"
                                  className="partsDrop"
                                  onClick={() => props.deleteClicked(data)}
                                >
                                  {DELETE_LABEL}
                                </div>
                              </div>
                            )}
                        </Box>
                      ) : (
                        data[item.id]
                      )}
                    </Box>
                  </ListItem>
})}
              </Box>
            ))
          ) : (
            <Box className="p-3">{NO_DATA_FOUND_TEXT}</Box>
          )}
        </List>
        <Pagination
          testid="pagination"
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={props?.totalRows ? props?.totalRows : rows?.length}
          pageSize={PageSize}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </Box>
    </>
  );
};
export default DataList;
